import { render, staticRenderFns } from "./ModalFormularioEditarPlanPagoUniversidad.vue?vue&type=template&id=204edba0"
import script from "./ModalFormularioEditarPlanPagoUniversidad.vue?vue&type=script&lang=js"
export * from "./ModalFormularioEditarPlanPagoUniversidad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports